import axios from '@fs/zion-axios'
import { buildLangUrl } from '@fs/zion-router'

/**
 * Gets the source language from an artifact or group, with a fallback to 'en'.
 * Checks the artifact's languages first, then falls back to the group's languages, and defaults to 'en' if neither is available.
 *
 * @param {Object} artifact - The artifact containing language information
 * @param {Object} group - The group data containing language information
 * @returns {string} The source language code or 'en' as fallback
 */
export function getSourceLanguage(artifact, group) {
  return artifact?.languages?.[0] || group?.languages?.[0] || 'en'
}

/**
 * Translates transcript text through our server, using Lara or ModernMT (translated.com).
 * @param {Object} params
 * @param {string} params.text - The text to translate
 * @param {string} params.sourceLanguage - The source language of the text
 * @param {string} params.targetLanguage - The language to translate to
 * @param {boolean} [params.isLaraOn=false] - Whether to translate with Lara instead of ModernMT
 * @returns {Promise<string>} Promise resolving to translated text
 */
export async function translateTranscript({ text, sourceLanguage, targetLanguage, isLaraOn = false }) {
  const route = isLaraOn ? '/records/improve/translate' : '/records/improve/translatedApi'
  // Put the locale in the path, or Snow answers with a 307 to the same URL with it added
  const response = await axios.post(buildLangUrl(route), {
    text,
    sourceLanguage,
    targetLanguage,
  })

  if (response.data.error) {
    throw new Error(`Translation failed: ${response.data.error}`)
  }

  return response.data.translation
}
